module.exports = __webpack_public_path__ + "img/pic_administration_staff.24cc2d31.jpg";